import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import {
  useInviteSuperAdminMutation,
  useVerifyEmailNotInUseLazyQuery
} from 'generated/graphql';
import {
  useLoading, validationUtil
} from 'modules';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';



const __formSchema = yup.object({
  firstName: validationUtil.nonEmptyStringSchema.required('First name is required.'),
  lastName: validationUtil.nonEmptyStringSchema.required('Last name is required.'),
  email: validationUtil.emailSchema.required('Email is required.'),
  password: validationUtil.passwordSchema.required('Password is required.'),
  confirmPassword: validationUtil.confirmPasswordSchema('password').required('Required.')
}).required();

export type IFormData = yup.InferType<typeof __formSchema>;



export function useAddSuperAdminModal() {
  const [inviteSuperAdmin, tuple] = __useInviteSuperAdminMutation();
  const [verifyEmailNotInUseQuery, verifyEmailInUseTuple] = __useVerifyEmailNotInUseQuery();
  const loading = useLoading([tuple, verifyEmailInUseTuple]);

  const form = useForm<IFormData>({
    resolver: yupResolver(__formSchema)
  });



  return {
    loading,
    form,
    data: {
      emailInUse: verifyEmailInUseTuple.data.isInUse
    },
    queries: {
      verifyEmailNotInUseQuery
    },
    mutations: {
      inviteSuperAdmin
    }
  };

}



function __useInviteSuperAdminMutation() {
  const [fnMutate, tuple] = useInviteSuperAdminMutation({});

  async function fnWrappedMutate(formData: IFormData) {
    await fnMutate({
      variables: {
        input: {
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          password: formData.password
        }
      }
    });
  }

  return [
    fnWrappedMutate,
    tuple
  ] as const;
}



function __useVerifyEmailNotInUseQuery() {
  const [fnQuery, tuple] = useVerifyEmailNotInUseLazyQuery();

  const wrappedTuple = React.useMemo(() => ({
    loading: tuple.loading,
    data: {
      isInUse: !(tuple.data?.verifyEmailNotInUse ?? true)
    }
  }), [tuple]);

  const fnWrappedQuery = React.useCallback(async (email: string) => {
    const result = await fnQuery({
      variables: { email },
      fetchPolicy: 'network-only'
    });

    return !(result.data?.verifyEmailNotInUse ?? true);
  }, [fnQuery]);

  return [
    fnWrappedQuery,
    wrappedTuple
  ] as const;
}
